<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  <div class="flex flex-col w-full h-full min-h-0 overflow-hidden p-1">

    <!-- Confirmation Dialog -->
    <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle">
    </p-confirmDialog>

    <!-- Phase Envelope Dialog -->
     @if (isLoading()) {
      <p-dialog modal="true" [(visible)]="phaseEnvelopeCalculating" [draggable]="false" [closable]="false" appendTo="self">
        <i class="pi pi-exclamation-circle pr-1"></i>
        <label>Please wait while Phase Envelope is being calculated</label>
        <br /><br />
      </p-dialog>
    }

    <!-- Collapse/Expand Button -->
    <p-button size="small" outlined="true" pTooltip="{{ drawerOpen ? 'Collapse List' : 'Expand List' }}"
      class="outlined-button" icon="{{ drawerOpen ? 'pi pi-angle-double-left' : 'pi pi-angle-double-right' }}"
      (onClick)="drawerToggle()">
    </p-button>

    <!-- Fluid Selector -->
      @if (!drawerOpen) {
      <p-select [options]="fluids" [ngModel]="selectedFluid()"
        optionLabel="state.name" dataKey="id" appendTo="body" (onChange)="onFluidSelect($event)" class="mt-2">
        <ng-template pTemplate="selectedItem">
          {{ selectedFluid()?.state?.name }}
        </ng-template>
        <ng-template let-fluid pTemplate="item">
          {{ fluid.state.name }}
        </ng-template>
      </p-select>
    }

    <div class="flex flex-1 min-h-0 overflow-hidden">
      <!-- Drawer Section -->
        @if (drawerOpen) {
        <div class="z-[2] flex-[0.3] min-w-[150px] min-h-0 flex-shrink overflow-auto">
          <p-listbox
            [scrollHeight]="''"
            [options]="selectedFluids"
            [ngModel]="selectedFluid()"
            [group]="true"
            optionGroupChildren="fluids"
            (onChange)="onFluidSelect($event)">

            <!-- Group Template -->
            <ng-template let-group #group>
              <div class="flex items-center justify-between" [style.background-color]="'var(--p-toolbar-background)'">
                <span style="color: #8086cb;" class="text-sm font-medium">{{ findDisplayName(group.type) }}</span>
                <div class="flex space-x-2">
                  <p-button text size="small" icon="pi pi-plus" [pTooltip]="'Add ' + findDisplayName(group.type)"
                    (onClick)="addFluid(group.type)">
                  </p-button>
                  <p-button text size="small"
                    [icon]="group.fluids.length > 0 ? 'pi pi-angle-double-down' : 'pi pi-angle-double-left'"
                    [pTooltip]="group.fluids.length > 0 ? 'Collapse ' + findDisplayName(group.type) : 'Expand ' + findDisplayName(group.type)"
                    (onClick)="expandGroup(group.type)">
                  </p-button>
                </div>
              </div>
            </ng-template>

            <!-- Item Template -->
            <ng-template let-fluid #item>
              <div class="flex items-center justify-between w-full">
                <span class="w-full text-sm truncate">
                  {{ fluid?.state?.name }}
                </span>

                <div class="flex items-center">
                  @if (fluid.state.co2withImpurities && !hideGergCalc) {
                    <i class="pi pi-play !text-green-400" [pTooltip]="'Calculate Phase Envelope'" (click)="calcGerg(fluid)"></i>
                  }
                  <i class="pi pi-copy p-1 !text-cyan-400" [pTooltip]="'Clone Fluid'" (click)="cloneFluid(fluid)"></i>
                  @if (!fluid?.isInUse && !checkDefaultFluid(fluid?.state?.name)) {
                    <i class="pi pi-trash !text-red-400" [pTooltip]="'Delete Fluid'" (click)="deleteFluid(fluid)"></i>
                  }
                  @if (fluid?.isInUse || checkDefaultFluid(fluid?.state?.name)) {
                    <i class="pi pi-lock !text-red-400" [pTooltip]="checkDefaultFluid(fluid?.state?.name) ? 'Fluid cannot be deleted' : 'Fluid is used in the design'"></i>
                  }
                </div>
              </div>
            </ng-template>

          </p-listbox>
        </div>
      }

      <!-- Main Content Section (Expands When Drawer is Hidden) -->
      <div [ngClass]="{'flex-[0.7]': drawerOpen, 'flex-[1]': !drawerOpen}" class="min-w-0 min-h-0 h-full p-2 overflow-hidden">
        @if (user) {
          <app-fluid-data
            [isReadOnly]="user?.roles?.readOnly"
            [fluid]="selectedFluid()"
            (fluidUpdate)="updateOrCreateFluid($event)"
            [disabled]="selectedFluid()?.isInUse || isDefaultFluid || isLoading()"
            [fluids]="fluids"
            [phaseEnvelopeCalculated]="phaseEnvelopeCalculated"
            [userUnits]="units"
            [isAltus]="user?.profile.organization === 'Altus'"
            [fluidsStore]="fluidsStore"
            [changeTrigger]="changeTrigger"
            [hideGergCalc]="hideGergCalc"
            class="block h-full min-h-0"
          ></app-fluid-data>
        }
      </div>
    </div>
  </div>
</app-tool-loader>